import React from 'react';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Filter from './Filter';

const styles = {
  accordionSummarySubtitle: {
    bgcolor: '#ecf1f4',
    height: '40px',
    minHeight: '40px',
    borderRadius: '4px',
    border: '1px solid #E0E0E0',
    fontWeight: '600',
    fontSize: '14px',
    '&.Mui-expanded': { margin: '0 !important', minHeight: 'unset !important' },
  },
  accordionDetails: {
    p: 1,
    borderRadius: '4px',
    boxShadown: 'none',
    display: 'flex',
    flexWrap: 'wrap ',
    '& .MuiBadge-badge': {
      right: 6,
      top: 8,
      padding: '0 4px',
    },
  },
};

const FilterAccordion = props => {
  const { facet, setSelectedFilters, setData, setError, setLoading } = props;
  const { title, filters } = facet || {};

  return (
    <Box my={2}>
      <Accordion>
        <AccordionSummary
          key={facet.id}
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`filter-${facet.id}-content`}
          id={`filter-${facet.id}-header`}
          sx={styles.accordionSummarySubtitle}
        >
          {title}
        </AccordionSummary>
        <AccordionDetails sx={styles.accordionDetails}>
          {filters.map(filter => (
            <Filter
              key={filter.value}
              filter={filter}
              setSelectedFilters={setSelectedFilters}
              setData={setData}
              setError={setError}
              setLoading={setLoading}
            />
          ))}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default FilterAccordion;
